import React, { useEffect, useState, useRef } from "react";
import api from "../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import * as Icon from 'react-feather';
import Swal from 'sweetalert2';

const UpdateProfileImage = (prop) => {
const {setUser} = useAuth()
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);
  const { onRefresh } = prop;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      if (objectUrl != preview) {
        setPreview(objectUrl);
        setValue("imgprofile", file, { shouldValidate: true });
        setSuccessUpload(null)
      }
    }
  };

  const {user} = useAuth();

  const FILE_SIZE = 2 * 1024 * 1024; // 2MB
  const schema = yup.object({
    imgprofile: yup
      .mixed()
      .required("Image is required")
      .test("fileSize", "File is too large (max 2MB)", value => {
        return value && value instanceof File && value.size <= FILE_SIZE;
      })
  });

  const {
    reset,
    handleSubmit,
    register,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    //defaultValues: inputValues,
  });

  const [LoadingUpload,setLoadingUpload] = useState(false)
  const [SuccessUpload,setSuccessUpload] = useState(null)

  const onSubmit = async(data) => {
    clearErrors();
    setSuccessUpload(null)

    let typeurl;
    
    if (user.type == "supplier") typeurl="/vendor-update-image/"
    else if (user.type == "agency") typeurl="/agency-update-image/"
    else return

    if (LoadingUpload) return;
    setLoadingUpload(true);
    
    try {
      const response = await api.post(typeurl, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); 

      console.log("Response Code:", response.status);

      reset();
      setSuccessUpload(response.data.result)
      
      setUser((prevUser) => ({
        ...prevUser,
        company: {
          ...prevUser.company,
          logo: response.data.url,
        },
      }));

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      if (onRefresh) onRefresh();

      document.querySelector('#update_image .btn-close')?.click();
    } catch (error) {
      console.log("dddddddddddddddddd");

      console.log(error);
      
      let  errorMessage = ""
      
      // Extract response code if available
      const responseCode = error.response ? error.response.status : "Unknown";
      console.log("Response Code:", responseCode);
      if (error?.response?.data) {   
        Object.entries(error.response.data).forEach(([key, values]) => {
          //if (key !== "token" && key !== "invite-agency-vendo") {
            console.log(key, values);
            errorMessage += `${values}\n`;
          //}
        });
      }
          
      // If no specific error was found, provide a default message
      if (!errorMessage) {
        errorMessage = "An unknown error occurred.";
      }
      
      // Set the error message in React Hook Form
      setError("root", { type: "server", message: errorMessage });
    } finally {
      setLoadingUpload(false);
    }
  }
  
  useEffect(()=>{
    clearErrors();

    const modal = document.getElementById('update_image');

    const handleHidden = () => {
      console.log('Modal closed!');
      reset();
      setPreview(null);
      setSuccessUpload(null)
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };

    if (modal) {
      modal.addEventListener('hidden.bs.modal', handleHidden);
    }

    return () => {
      if (modal) {
        modal.removeEventListener('hidden.bs.modal', handleHidden);
      }
    };
  },[])
  
  return (
    <div className="modal custom-modal modal-lg fade" id="update_image" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="form-header modal-header-title text-start mb-0">
              <h4 className="mb-0">Update Profile Image</h4>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form  onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="card-body">
                    <div className="form-groups-item">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-block mb-3">
                            <div className="d-flex justify-content-center mt-4">
                              <div className="position-relative mb-3 rounded border border-secondary d-flex justify-content-center align-items-center overflow-hidden bg-light" onClick={() => fileInputRef.current.click()}
                                style={{ width: '150px', height: '150px', cursor: 'pointer' }}>
                                {preview ? (
                                  <img
                                    src={preview}
                                    alt="Profile"
                                    className="w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                  />
                                ) : (
                                  <Icon.User size={40}/>
                                )}
                              </div>
                            </div>
                            <label htmlFor="upload-photo">Upload Company Logo</label>
                            <input
                              id="upload-photo"
                              type="file"
                              name="imgprofile"
                              accept="image/*"
                              ref={fileInputRef}
                              onChange={handleImageChange}
                              className="form-control"
                            />
                            {/* {SuccessUpload && <p style={{color:"green"}}>{SuccessUpload}</p>} */}
                            {errors.imgprofile && (
                              <p className="text-danger">{errors.imgprofile.message}</p>
                            )}
                            {errors.root && <p style={{color:"red"}}>{errors.root.message}</p>}
                            {/* <input type="email"
                              {...register("email")}
                              className="form-control" placeholder="Enter Email Address" />
                            <small>{errors?.email?.message}</small> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
              {SuccessUpload ?
                <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                  Image Updated
                </button>
                :
                <button type="submit"  className="btn btn-primary">
                  Apply Changes
                  {LoadingUpload && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i>}
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  ); 
};

export default UpdateProfileImage ;
